import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsentManager } from 'src/components/App/hooks/useConsentManager';
import { initializeRWA } from 'src/shared/services/RWA';
import { useSpectrometer } from './useSpectrometer';

export const useAnalytics = () => {
  const location = useLocation();

  useConsentManager();

  useEffect(() => {
    initializeRWA();
  }, []);

  // Create RWA page view on route changes
  useEffect(() => {
    if (!window.RWA) return;

    try {
      window.RWA.createPageView({
        path: location.pathname,
        title: document.title,
        qs: location.search,
        hash: location.hash,
      });
    } catch (error) {
      console.error('Failed to create RWA page view:', error);
    }
  }, [location.pathname, location.search, location.hash]);

  useSpectrometer();
};
